"use client";

import { use } from "react";

import { AuthStep } from "@/components/onboarding/auth-step";

type LoginPageProps = {
  searchParams: Promise<{ error?: string | string[] }>;
};

function firstParam(error: string | string[] | undefined) {
  return Array.isArray(error) ? error[0] : error;
}

// `invite_required` is surfaced as a modal (see below); only `auth` shows inline.
function inlineErrorFromParam(error: string | string[] | undefined) {
  if (firstParam(error) === "auth") {
    return "We could not complete sign-in. Try again.";
  }
  return null;
}

export default function LoginPage({ searchParams }: LoginPageProps) {
  const params = use(searchParams);

  return (
    <AuthStep
      initialError={inlineErrorFromParam(params.error)}
      initialShowInviteModal={firstParam(params.error) === "invite_required"}
    />
  );
}
